<template>
<div v-if="user">
  <h5>Dashboard</h5>
  <hr>
  <div>
    <barangay-analytics v-if="user.is_barangay_leader" :barangay_id="user.barangay_id"></barangay-analytics>
    <admin-overview v-else></admin-overview>
  </div>

</div>
</template>

<script>
import EmployerOverview from './EmployerOverview.vue'
import { Message } from 'element-ui';
import AdminOverview from './AdminOverview.vue';
import BarangayAnalytics from '../../../System/Barangays/BarangayAnalytics.vue';

export default {
  components: {
    EmployerOverview,
    AdminOverview,
    BarangayAnalytics,
  },
  data() {
    return {
      user: null
    }
  },
  created: function () {
    this.user = this.$store.state.user
    if (this.$route.query.login) {
      Message({
        duration: 5000,
        message: 'WELCOME '+this.user.name.toUpperCase(),
        type: 'success'
      });
      this.$router.replace({ query: {} });
    }
    
    if (this.$route.query.refresh) {
      this.$router.push({
        name: 'Home'
      })
      window.location.reload()
    }
  }
}
</script>

<style>

</style>
